export default "__VITE_ASSET__qvyP5FPt__"